module.exports = {
      id: "backward-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#backward",
      toString: function () {
        return this.url;
      }
    }